import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useMatchUpdate } from 'projectSpecific/sports/useHelpers/useMatchUpdate'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Icon, Label } from 'semantic-ui-react'
import SportsAthletes from '../athletes/SportsAthletes'
import { _sdm } from '../dashboard/SportsDashboard'
import MatchDataUpdate from '../matches/MatchDataUpdate'
import SportsSeasons from '../seasons/SportsSeasons'
import MatchResults from '../matches/MatchResults'
import { GroupSquares } from 'global/wrappers/GroupSquares'

const _sportsInfoItems = {
  options: 'options',
  matchResults: 'matchResults',
  pastSeasons: 'pastSeasons',
  teamRosters: 'teamRosters',
  teams: 'teams',
  updateMatchDayResults: 'updateMatchDayResults',
  appUserCount: 'appUserCount',
}
export const _resultModes = {
  ammend: 'ammend',
  backup: 'backup',
  export: 'export',
  media: 'media',
  openExternal: 'openExternal',
  scores: 'scores',
  search: 'search',
}

export const SportInfoSquares = ({ menuItems }) => {

  const location = useLocation()
  const navigate = useNavigate();
  const { updateMatchResults_fromMatchDay } = useMatchUpdate()

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { dailyCounts, currentUserCount, lastItemCount } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matchDayResults, teams_info } = sportsSeason_state ?? {};
  const { teams } = teams_info ?? {};

  const [selectedSportItem, setSelectedSportItem] = useState()

  const sportInfoItems = useMemo(() => {
    if (!isAdminOrSuper) {
      return _.omit(_sportsInfoItems, [
        _sportsInfoItems.appUserCount,
        _sportsInfoItems.matchResults,
        _sportsInfoItems.updateMatchDayResults,
      ])
    }
    return _sportsInfoItems
  }, [isAdminOrSuper])


  const oc_team = (item) => {
    navigate(`${location.pathname}/teams/${item?._itemKey}`)
  }

  const oc_update = () => {
    updateMatchResults_fromMatchDay({ matchDayResults })
  }

  const fnIcon = (item) => {
    switch (item) {
      case _sportsInfoItems.pastSeasons:
        return 'calendar outline'

      case _sportsInfoItems.teams:
      case _sportsInfoItems.teamRosters:
        return 'users'

      case _sportsInfoItems.matchResults:
        return 'trophy'

      case _sportsInfoItems.appUserCount:
        return 'hashtag'

      case _sportsInfoItems.updateResults:
      case _sportsInfoItems.updateMatchDayResults:
        return 'edit'

      // case _sportsInfoItems.favorites:
      //   return 'heart'
    }
    return 'cog'
  }

  const fnAlt = (item) => {
    switch (item) {
      case _sportsInfoItems.updateMatchDayResults:
        return <Label size='mini' color='blue'>{_.size(matchDayResults)}</Label>
      case _sportsInfoItems.appUserCount:
        return <Label size='mini' color='blue'>{`${dailyCounts?.todaysCount?.count}/${lastItemCount}/${currentUserCount}`}</Label>
    }
  }

  const content_currentGroup = (cg) => {
    // if (allGroups) {
    const _currentGroup = cg //|| currentGroup
    const { key, menuItems, value } = _currentGroup ?? {}
    switch (key) {
      case _sportsInfoItems.updateMatchDayResults:
        oc_update()

      case _sportsInfoItems.pastSeasons:
        return <SportsSeasons handleCancel={setSelectedSportItem} noFull={true} />

      case _sportsInfoItems.teamRosters:
        return <SportsAthletes sportsDisplayType={selectedSportItem} handleCancel={setSelectedSportItem} />

      case _sportsInfoItems.matchResults:
        // return <ItemMenuSquares
        //   imsType={_imsTypes.normal}
        //   menuItems={_resultModes}
        //   iconItem={'users'}
        //   onClick={oc}
        // />
        return <MatchResults
          fromApp={true}
          forSportsManagement={true}
          sportsDataMode={_sdm.sports.seasonResults}
          handleCancel={setSelectedSportItem}
          noFull={true}
        />
      case _sportsInfoItems.appUserCount:
        return <div>appUserCount</div>

      case _sportsInfoItems.teams:
        return <ItemMenuSquares
          imsType={_imsTypes.normal}
          menuItems={_.sortBy(teams, 'name')}
          iconItem={'users'}
          onClick={oc_team}
        />
    }
  }

  return <GroupSquares
    menuItems={sportInfoItems}
    fnCurrentGroup={content_currentGroup}
    fnAlt={fnAlt}
    fnIcon={fnIcon}
    caption={'Sports Options'}
  />

}
